import * as React from 'react';
import { LoadOptions } from 'app/types-shared';
import { CodeSinglePicker } from 'app/area/codetable/common';
import { ScreenPickerProps, ScreenPicker } from 'app/area/codetable/item/screen-renderer/types';
import { codetableOptionsIds } from 'app/area/codetable/item/screen-renderer/screen-pickers/constants';
import { ReadOnlyType } from 'app/area/codetable/item/types';
import { configurationAlreadyExistsKey } from 'app/area/indicator-factors/constants';
import { CodetableTranslation } from 'app/area/codetable/constants';
import { manageOptionsButton } from 'app/area/shared/manage-options';
import { CodeComplexValue } from 'app/area/shared/codetable/types';

export type LikelihoodProps = ScreenPickerProps & {
  likelihoodLabel: (translation: CodetableTranslation) => string;
  isLikelihoodRequired?: boolean;
};

export const Likelihood = (props: LikelihoodProps) => {

  const { codeItem, updateByKey, resetValidation, codetableOptions, loadCodetableOptions, translation, validation, readOnlyConfig,
    likelihoodLabel, breadcrumbs, isLikelihoodRequired } = props;

  const onChange = (value: CodeComplexValue<number>) => {
    resetValidation(ScreenPicker.likelihood);
    if (validation.category && validation[configurationAlreadyExistsKey]) {
      resetValidation(ScreenPicker.category);
      resetValidation(configurationAlreadyExistsKey);
    }
    updateByKey(ScreenPicker.likelihood, value);
  };

  const onLoadOptions = (id: string, loadOptionsParams: LoadOptions) => {
    loadCodetableOptions(id, codetableOptionsIds.likelihood, loadOptionsParams);
  };

  const codeOptions = (!!codetableOptions.likelihood && codetableOptions.likelihood.codes || []) as CodeComplexValue<number>[];

  const likelihoodValidation = !!validation && !!validation.likelihood ? validation.likelihood : undefined;

  const codetableId = codetableOptionsIds[ScreenPicker.likelihood];

  const extraFooterButton = manageOptionsButton(translation.manage_options, codetableId, breadcrumbs);

  const readOnly = readOnlyConfig && readOnlyConfig[ReadOnlyType.all];

  const required = isLikelihoodRequired ?? !readOnly;

  return <CodeSinglePicker
    id={ScreenPicker.likelihood}
    label={likelihoodLabel?.(translation) ?? translation.likelihood}
    valueItem={codeItem && codeItem.likelihood}
    searchRequired={false}
    required={required}
    readOnly={readOnly}
    options={codeOptions}
    fetchingOptions={codetableOptions.likelihood && codetableOptions.likelihood.fetching}
    extraFooterButton={extraFooterButton}
    translation={translation}

    onLoadOptions={onLoadOptions}
    onChange={onChange}
    validation={likelihoodValidation}
  />;
};
